import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Tester, TestResult, Test } from './models';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable()
export class TestService {
  constructor(private _http: HttpClient) {}

  saveUserAnswer(
    testAssignmentId: number,
    questionId: number,
    answerId: number
  ): Observable<boolean> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const r = {
      testAssignmentId: testAssignmentId,
      questionId: questionId,
      answerId: answerId,
    };

    return this._http
      .post('api/test/submitAnswer', JSON.stringify(r), httpOptions)
      .pipe(map(response => response as boolean));
  }

  fetchTester(testAssignmentId: number): Observable<Tester> {
    return this._http
      .get('api/test/getTester/' + testAssignmentId)
      .pipe(map(response => new Tester(response)));
  }

  updateTestStatusAsComplete(testAssignmentId: number): Observable<TestResult> {
    return this._http
      .get('api/test/testComplete/' + testAssignmentId)
      .pipe(map(response => new TestResult(response)));
  }

  fetchTest(testAssignmentId: number): Observable<Test> {
    return this._http
      .get('api/test/getTest/' + testAssignmentId)
      .pipe(map(response => new Test(response)));
  }

  getTestData(testAssignmentId: number): Observable<Tester> {
    return this._http
      .get('api/test/getTestData/' + testAssignmentId)
      .pipe(map(response => new Tester(response)));
  }
}
